// extracted by mini-css-extract-plugin
export default {"container":"_2UtL","mentorsContainer":"_2ATb","degreesContainer":"KqSs"};